<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{
          this.operatorBeingEdited._id
            ? $t("operators.editOperator")
            : $t("operators.createOperator")
        }}
      </p>
    </header>

    <section class="modal-card-body">
      <h2 class="subtitle">{{ $t("operators.personalData") }}</h2>

      <div class="columns">
        <div class="column">
          <b-field :label="$t('operators.name')" label-position="on-border">
            <b-input v-model="operator.personalInfo.name"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('operators.email')" label-position="on-border">
            <b-input v-model="operator.personalInfo.email"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="$t('operators.cellphone')"
            label-position="on-border"
          >
            <vue-tel-input
              v-model="operator.personalInfo.cellphone"
              :inputOptions="{
                placeholder: $t('operators.cellphoneWithAreaCode')
              }"
              :dropdownOptions="{
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true
              }"
              validCharactersOnly
              @validate="vueTelValidate"
              :defaultCountry="defaultCountry"
              :preferredCountries="preferredCountries"
            ></vue-tel-input>
          </b-field>
        </div>
      </div>

      <br />

      <h2 class="subtitle">
        {{ $t("operators.permissionsMerchantWeb") }}
      </h2>

      <div v-if="stores.length > 0" class="permissions-group">
        <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.general") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="accessMerchant" />

        <permission pclass="bottom-permission-p" permission="seeBIDashboard" />

        <permission pclass="bottom-permission-p" permission="seeBilling" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsPurchases") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seePurchases" />

        <permission
          pclass="bottom-permission-p"
          permission="downloadPurchasesReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="addUpdatePurchase"
        />

        <permission
          pclass="bottom-permission-p"
          permission="bulkAddUpdatePurchases"
        />

        <permission pclass="bottom-permission-p" permission="removePurchase" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsProductCreation") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="createProducts" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsCatalog") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeProducts" />

        <permission
          pclass="bottom-permission-p"
          permission="addProductToCatalogUpdatePrice"
        />

        <permission
          pclass="bottom-permission-p"
          permission="bulkAddProductToCatalogUpdatePrice"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeStockValueSummary"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductCostTableColumn"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductMarginTableColumn"
        />

        <permission
          pclass="bottom-permission-p"
          permission="removeProductFromCatalog"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductIdealQty"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductCurrentQty"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductValidity"
        />

        <permission pclass="bottom-permission-p" permission="manageTaxes" />

        <permission
          pclass="bottom-permission-p"
          permission="downloadStoresProductsReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadAllOniiProductsReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadCompletePlanogramReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadRefillPlanogramReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeRefillsAndInventories"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadRefillsAndInventories"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateCriticalStockLevel"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsClients") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeStoreClientName" />

        <permission
          pclass="bottom-permission-p"
          permission="seeStoreClientSurname"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeStoreClientEmail"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeStoreClientCellphone"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeStoreClientPersonalId"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeBlockedClients"
        />

        <permission pclass="bottom-permission-p" permission="blockClient" />

        <permission pclass="bottom-permission-p" permission="unblockClient" />
        <permission pclass="bottom-permission-p" permission="seeClients" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsAccesses") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeAccessesPage" />

        <permission
          pclass="bottom-permission-p"
          permission="downloadAccessesReport"
        />

        <permission pclass="bottom-permission-p" permission="seeAccessStatus" />

        <permission
          pclass="bottom-permission-p"
          permission="changeAccessStatus"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsTransactions") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="seeTransactionsPage"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeTransactionsSummary"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadTransactionsReport"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsSettlements") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeSettlements" />

        <permission
          pclass="bottom-permission-p"
          permission="downloadSettlementsReport"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsCashback") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeCashbacks" />

        <permission pclass="bottom-permission-p" permission="cedeCashback" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsFeedback") }}</b>
        </p>

        <permission
          pclass="bottom-permission-p"
          permission="seeFeedbacksPage"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadFeedbacksReport"
        />

        <permission
          pclass="bottom-permission-p"
          permission="changeFeedbackStatus"
        />

        <!-- <permission pclass="bottom-permission-p" permission="answerFeedback" /> -->

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsStoreConfigs") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeStoreConfigs" />

        <permission
          pclass="bottom-permission-p"
          permission="manageStoreStatus"
        />

        <permission pclass="bottom-permission-p" permission="managePayments" />

        <permission pclass="bottom-permission-p" permission="manageCashback" />

        <permission pclass="bottom-permission-p" permission="manageCoupon" />

        <permission
          pclass="bottom-permission-p"
          permission="managePromotionalImage"
        />

        <permission
          pclass="bottom-permission-p"
          permission="managePromotionsOptin"
        />

        <permission
          pclass="bottom-permission-p"
          permission="manageAccessControl"
        />

        <!-- <permission
          pclass="bottom-permission-p"
          permission="manageMealVouchers"
        /> -->

        <permission
          pclass="bottom-permission-p"
          permission="manageNotFoundProductsActions"
        />

        <permission
          pclass="bottom-permission-p"
          permission="manageCatalogActions"
        />
      </div>

      <div class="permissions-group">
        <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.purchasesInvoices") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="canSeePurchasesInvoices"
        />
        <permission
          pclass="bottom-permission-p"
          permission="canSyncPurchasesInvoices"
        />
      </div>

      <div class="permissions-groups">
        <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.Stockout") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeStockouts" />
      </div>

      <div v-if="lockers.length > 0" class="permissions-group">
        <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsDeliveries") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="seeOpenDeliveries" />

        <permission
          pclass="bottom-permission-p"
          permission="seeAllDeliveries"
        />

        <permission
          pclass="bottom-permission-p"
          permission="downloadLockerDeliveriesReport"
        />

        <permission pclass="bottom-permission-p" permission="makeDelivery" />

        <!-- <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsClients") }}</b>
        </p> -->
      </div>

      <div
        v-if="stores.length > 0"
        style="margin-top: 2rem; margin-bottom: 3rem;"
      >
        <h2 class="subtitle">
          {{ $t("operators.permissionsMerchoniiApp") }}
        </h2>

        <p style="margin-bottom: 1rem;">
          <b>{{ $t("operators.general") }}</b>
        </p>

        <permission pclass="top-permission-p" permission="accessMerchonii" />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsPurchases") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="seeProductCostMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductCostMerchonii"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsTransactions") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="seeTransactionsPageMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeTransactionsSummaryMerchonii"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsProductCreation") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="addproductToOniiBaseMerchonii"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.permissionsCatalog") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="seeProductsMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="addproductToStoreCatalogMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductPriceMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductPriceMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductMarginMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductIdealQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductMinimumQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductMinimumQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductIdealQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductCurrentQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductCurrentQuantityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="seeProductValidityMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="updateProductValidityMerchonii"
        />

        <permission
          v-show="hasVipStore"
          pclass="bottom-permission-p"
          permission="seeProductVipPriceMerchonii"
        />

        <permission
          v-show="hasVipStore"
          pclass="bottom-permission-p"
          permission="updateProductVipPriceMerchonii"
        />

        <p style="margin-top: 2rem; margin-bottom: 1rem;">
          <b>{{ $t("operators.operations") }}</b>
        </p>

        <permission
          pclass="top-permission-p"
          permission="makeRefillMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="makeFullInventoryMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="makePartialInventoryMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="reportLossMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="manageTaxesMerchonii"
        />

        <permission
          pclass="bottom-permission-p"
          permission="reportLossMerchonii"
        />
      </div>
    </section>

    <footer class="modal-card-foot columns">
      <div class="column has-text-centered" style="padding: 0; margin: 0;">
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("common.cancel") }}
        </button>
      </div>

      <div class="column has-text-centered">
        <button
          class="button"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          @click="createUpdateOperator"
          :disabled="!isTelValid"
        >
          {{
            this.operatorBeingEdited._id
              ? $t("operators.update")
              : $t("operators.create")
          }}
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import permission from "./Permission";

export default {
  props: ["operatorBeingEdited"],

  mixins: [common],

  components: {
    permission
  },

  data() {
    return {
      operator: {
        personalInfo: {
          name: "",
          email: "",
          countryCallingCode: "",
          cellphone: "",
          countryCode: ""
        },
        permissions: {
          // Merchant Web Lojas

          accessMerchant: false,
          seePurchases: false,
          downloadPurchasesReport: false,
          addUpdatePurchase: false,
          bulkAddUpdatePurchases: false,
          removePurchase: false,
          createProducts: false,
          seeProducts: false,
          addProductToCatalogUpdatePrice: false,
          bulkAddProductToCatalogUpdatePrice: false,
          seeStockValueSummary: false,
          seeProductCostTableColumn: false,
          seeProductMarginTableColumn: false,
          removeProductFromCatalog: false,
          updateProductIdealQty: false,
          updateProductCurrentQty: false,
          updateProductValidity: false,
          manageTaxes: false,
          downloadStoresProductsReport: false,
          downloadAllOniiProductsReport: false,
          downloadCompletePlanogramReport: false,
          downloadRefillPlanogramReport: false,
          seeStoreClientName: false,
          seeStoreClientSurname: false,
          seeStoreClientEmail: false,
          seeStoreClientCellphone: false,
          seeStoreClientPersonalId: false,
          seeBlockedClients: false,
          blockClient: false,
          unblockClient: false,
          seeAccessesPage: false,
          downloadAccessesReport: false,
          seeAccessStatus: false,
          changeAccessStatus: false,
          seeTransactionsPage: false,
          seeTransactionsSummary: false,
          downloadTransactionsReport: false,
          seeSettlements: false,
          downloadSettlementsReport: false,
          seeCashbacks: false,
          cedeCashback: false,
          seeFeedbacksPage: false,
          downloadFeedbacksReport: false,
          changeFeedbackStatus: false,
          answerFeedback: false,
          seeStoreConfigs: false,
          manageStoreStatus: false,
          managePayments: false,
          manageCashback: false,
          managePromotionsOptin: false,
          manageAccessControl: false,
          manageMealVouchers: false,
          manageNotFoundProductsActions: false,
          manageCatalogActions: false,
          seeRefillsAndInventories: false,
          seeClients: false,
          seeStockouts: false,

          // NFs de Entrada
          canSeePurchasesInvoices: false,
          canSyncPurchasesInvoices: false,

          // Merchant Web Lockers

          seeOpenDeliveries: false,
          seeAllDeliveries: false,
          downloadLockerDeliveriesReport: false,
          makeDelivery: false,

          // Merchonii App

          accessMerchonii: false,
          seeTransactionsPageMerchonii: false,
          seeTransactionsSummaryMerchonii: false,
          seeProductCostMerchonii: false,
          updateProductCostMerchonii: false,
          seeProductsMerchonii: false,
          seeProductPriceMerchonii: false,
          updateProductPriceMerchonii: false,
          seeProductMarginMerchonii: false,
          seeProductIdealQuantityMerchonii: false,
          updateProductIdealQuantityMerchonii: false,
          seeProductCurrentQuantityMerchonii: false,
          updateProductCurrentQuantityMerchonii: false,
          seeProductValidityMerchonii: false,
          updateProductValidityMerchonii: false,
          addproductToOniiBaseMerchonii: false,
          addproductToStoreCatalogMerchonii: false,
          makeRefillMerchonii: false,
          makeFullInventoryMerchonii: false,
          makePartialInventoryMerchonii: false,
          manageTaxesMerchonii: false,
          seeProductVipPriceMerchonii: false,
          updateProductVipPriceMerchonii: false,
          seeProductMinimumQuantityMerchonii: false,
          updateProductMinimumQuantityMerchonii: false
        }
      },
      defaultCountry: "BR",
      preferredCountries: ["BR", "PT", "ES"],
      isTelValid: false,
      isLoading: false
    };
  },

  methods: {
    vueTelValidate(t) {
      this.operator.personalInfo.countryCode = t.countryCode;
      this.operator.personalInfo.countryCallingCode = t.country.dialCode;
      this.isTelValid = t.valid;
    },

    createUpdateOperator() {
      if (this.operatorBeingEdited._id) {
        this.updateOperator();
      } else {
        this.createOperator();
      }
    },

    createOperator() {
      this.isLoading = true;
      this.operator.personalInfo.originalEmail = this.operator.personalInfo.email;
      this.$store
        .dispatch("createOperator", { operator: this.operator })
        .then(res => {
          if (res.data.result === "ok") {
            this.$parent.close();
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateOperator() {
      this.isLoading = true;
      this.$store
        .dispatch("updateOperator", { operator: this.operator })
        .then(res => {
          if (res.data.result === "ok") {
            this.$emit("get-operators");
            this.$parent.close();
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["stores", "lockers"]),
    hasVipStore() {
      return this.stores.find(s => s.configs && s.configs.vipActive === true);
    }
  },

  mounted() {
    if (this.operatorBeingEdited._id) {
      this.operator = this.operatorBeingEdited;
    }
  }
};
</script>

<style scoped>
.permissions-group {
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.switch-adjusted-top {
  position: relative;
  top: 2px;
}
.top-permission-p {
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.bottom-permission-p {
  border-bottom: 1px solid lightgrey;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
</style>
